import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

/**
 * Canonical page-body geometry, owned here so no screen invents its own.
 *
 * DEC-GS-WIDTH — one width: R-050's `--layout-page-max` (1440px), the point at
 * which content stops growing (addendum §4, "not a breakpoint"). The older
 * Golden shell carried three widths (1040 / 1200 / 1360); the governing R-050
 * token replaces them, and no screen used the other two. Gutters live in
 * `.fd-workspace-content` (24px, 32px at ≥1600px), not here, so every instance
 * shares one rule.
 */
export function WorkspaceContent({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn('fd-workspace-content mx-auto w-full max-w-(--layout-page-max)', className)}>
      {children}
    </div>
  );
}
